<template>
  <v-container
    fluid
    class="pa-0">

    <v-row
      v-for="(feedbackDetails, ind) in feedback"
      :key="ind"
    >
      <v-col cols="12">
        <v-card
          shaped
          class="rounded-corner"
        >
          <v-card-subtitle class="text-overline pl-4 pr-4 pt-2 pb-2">
            {{ feedbackDetails.sessionDetails.event_name }}
          </v-card-subtitle>
          <v-card-text class="text--primary">

            <div> <v-icon
              small
              color="teal">date_range</v-icon> {{ feedbackDetails.interviewDate }} at {{ feedbackDetails.timeSlot }}</div>
            <div><v-icon
              small
              color="teal">person_outline</v-icon> {{ feedbackDetails.teacher }} </div>
            <div><v-icon
              x-small
              color="teal">fas fa-comment-dots</v-icon> {{ feedbackDetails.feedback }} </div>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    feedback: {
      type: Object,
      default: () => { return {} }
    }
  },

  components: {

  },

  data: function () {
    return {
      tealColor: '#00B0B9',
      alertMsg: '',
      alertColor: ''

    }
  },

  computed: {
    ...mapState(['Dbasename', 'schoolId', 'status', 'teacherId', 'teacherName', 'loadingDialog', 'withPinSetup']),
    alert: function () {
      if (this.alertMsg !== '') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {

  }
}
</script>
<style scoped>
.rounded-corner{
    border-radius:10px;
}
</style>
